import {Lotties} from "./Lotties";
import * as failResult from "../../../../assets/themes/squareone/lotties/fail.json";
import * as pendingResult from "../../../../assets/lotties/Emerge_Lottie_ID_Positive_CheckingInfo.json";
import * as successTick from "../../../../assets/themes/vastbank/lotties/tick.json";
import * as processingID from "../../../../assets/themes/squareone/lotties/processing-id.json";
import * as processingSelfie from "../../../../assets/themes/squareone/lotties/processing-selfie.json";
import * as reviewResult from "../../../../assets/themes/squareone/lotties/review.json";
import * as passResult from "../../../../assets/themes/squareone/lotties/success.json";

export const SquareOneLotties: Lotties = {
    fail: failResult,
    pending: pendingResult,
    processComplete: successTick,
    processingId: processingID,
    processing: processingID,
    processingSelfie: processingSelfie,
    review: reviewResult,
    success: passResult,
    error: failResult
}